/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CheckPhoneDto } from '../models/CheckPhoneDto';
import type { CheckPhoneResponseDto } from '../models/CheckPhoneResponseDto';
import type { ConvertLeadDto } from '../models/ConvertLeadDto';
import type { HandoffApplicantDto } from '../models/HandoffApplicantDto';
import type { HandoffResponseDto } from '../models/HandoffResponseDto';
import type { ResolveHandoffDto } from '../models/ResolveHandoffDto';
import type { ResolveHandoffResponseDto } from '../models/ResolveHandoffResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WebOnboardingService {
    /**
     * Accept an applicant from the marketing Application Form (partner authenticated)
     * The entry point for the handoff. The marketing team owns the Application Form on their landing pages; this records the applicant and returns a single-use reference to redirect with, so no name, email or phone number travels in a URL. The phone may be sent as phone_dial_code + phone_national, or as one combined E.164 phone. The dial code determines billing currency, so a number without one — or with a code for a country we do not operate in — is rejected rather than defaulted. Send event_id to make retries safe: repeating it returns the applicant already recorded instead of creating a second one. Fires applicant.created. Redirect the applicant to redirect_url verbatim; it expires in 30 minutes.
     * @param xJfitPartnerKey Shared partner key. Required.
     * @param requestBody
     * @returns HandoffResponseDto Applicant accepted
     * @throws ApiError
     */
    public static webOnboardingControllerHandoffV1(
        xJfitPartnerKey: string,
        requestBody: HandoffApplicantDto,
    ): CancelablePromise<HandoffResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/web-onboarding/handoff',
            headers: {
                'x-jfit-partner-key': xJfitPartnerKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed or unsupported country code`,
                401: `Missing or invalid partner key`,
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * Exchange a handoff reference for the applicant details (public)
     * Called by the join flow when an applicant lands with ?ref=. Reading does not consume the reference — handoff/consume does that, once the code has actually been sent — but it does shorten the reference TTL to five minutes, so a link that has been seen is short-lived whether or not verification succeeded.
     * @param requestBody
     * @returns ResolveHandoffResponseDto Applicant resolved
     * @throws ApiError
     */
    public static webOnboardingControllerResolveHandoffV1(
        requestBody: ResolveHandoffDto,
    ): CancelablePromise<ResolveHandoffResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/web-onboarding/handoff/resolve',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Reference expired, already used, or unknown`,
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * Retire a handoff reference once verification has started (public)
     * Called by the join flow after the OTP has been sent and the flow cookie issued. Split from resolve so that a failure in between — a rate-limited SMS, most likely — leaves the applicant's link usable rather than stranding them on a dead one.
     * @param requestBody
     * @returns any Reference retired
     * @throws ApiError
     */
    public static webOnboardingControllerConsumeHandoffV1(
        requestBody: ResolveHandoffDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/web-onboarding/handoff/consume',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * Check what the web flow should do with a phone number (public)
     * Runs before an OTP is sent, so a returning applicant is not charged an SMS only to hit a 403 at role selection. Returns one of: new (register), resumable (log in and continue), expert_complete (already onboarded — send to the app), client_conflict (registered as a client; no self-service path to expert exists, route to support). Reveals whether a number is registered, so it is rate limited and must stay behind the captcha guard.
     * @param requestBody
     * @returns CheckPhoneResponseDto Phone checked
     * @throws ApiError
     */
    public static webOnboardingControllerCheckPhoneV1(
        requestBody: CheckPhoneDto,
    ): CancelablePromise<CheckPhoneResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/web-onboarding/phone-check',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed`,
                429: `Rate limit exceeded`,
            },
        });
    }
    /**
     * Link a lead to the account created from it
     * Called once OTP verification has created the users row. Sets expert_leads.user_id and converted_at, copies the lead attribution onto the user, and marks signup_platform as web so Expert Management can distinguish app from web signups — all in one transaction. Idempotent and forgiving: a missing or already-linked lead returns converted=false rather than an error, so a stale flow cookie never strands a legitimate applicant mid-flow.
     * @param requestBody
     * @returns any Conversion processed
     * @throws ApiError
     */
    public static webOnboardingControllerConvertLeadV1(
        requestBody: ConvertLeadDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/web-onboarding/leads/convert',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed`,
                401: `Unauthorized`,
            },
        });
    }
}
